"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const store_1 = require("../context/store");
const fiatCurrencies_1 = __importDefault(require("../data/fiatCurrencies"));
const useFiatCurrency = () => {
    const { selectedFiat } = (0, store_1.useTrackedState)();
    const [fiatCurrency, setFiatCurrency] = (0, react_1.useState)();
    (0, react_1.useEffect)(() => {
        const fiat = fiatCurrencies_1.default.find((i) => i.abbr === selectedFiat);
        setFiatCurrency(fiat);
    }, [selectedFiat]);
    return fiatCurrency;
};
exports.default = useFiatCurrency;
//# sourceMappingURL=useFiatCurrency.js.map